'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { Highlight } from '@eliadmin/core/src/components/ui/highlight';
import Link from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';

export type SearchBarBlogProps = {
  blog: Blog & { id: number };
  className?: {
    root?: string;
    imageContainer?: string;
    image?: string;
    info?: string;
    name?: string;
    description?: string;
  };
  searchQuery?: string;
};

export function SearchBarBlog({ blog, className, searchQuery }: SearchBarBlogProps) {
  function extractTextFromHtml(htmlContent: any) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  return (
    <Link
      key={blog.id}
      href={blog.slug}
      className={cn(
        'flex cursor-pointer items-center justify-start gap-2 p-4 hover:bg-gray-50',
        'ea-search-bar__product',
        className?.root,
      )}
    >
      {!!blog.image && (
        <span className="relative h-12 w-12 shrink-0 overflow-hidden rounded-sm">
          <Image
            alt={resolveImageAlt(blog?.image, blog?.name, 'image')}
            src={blog.image?.url ?? '/images/placeholder.png'}
            fill
            sizes="48px"
            className={cn('ea-search-bar__product-image', className?.image)}
            style={{ objectFit: 'cover', objectPosition: 'center' }}
          />
        </span>
      )}
      <div
        className={cn(
          'flex w-full flex-col items-start justify-start gap-0',
          'ea-search-bar__product-info',
          className?.info,
        )}
      >
        <h6 className="w-full text-sm font-semibold sm:text-base">{blog.name}</h6>

        {/* TODO:
            highlight product description with some html rendering magic
        */}
        <HtmlRenderer
          className={cn(
            'line-clamp-2 text-ellipsis text-sm text-muted-foreground',
            'ea-search-bar__product-description',
            className?.description,
          )}
          html={blog.content}
        />
      </div>
    </Link>
  );
}
